// Libraries
import styled from 'styled-components'

// Components
import { Aligner, Body, Button, FormButton, InputText } from 'heeds-ds'

type Props = {
  visible?: boolean
}

export const Container = styled.div<Props>`
  ${({ visible }) =>
    visible && 'box-shadow: 0px 4px 20px rgba(99, 90, 108, 0.1)'};
  background: ${({ theme }) => theme.colors.surface.default};
  border-left: 4px solid ${({ theme }) => theme.colors.icon.default};
  border-radius: 4px;
  padding: 16px 16px 0 8px;
  width: 100%;
  overflow-y: scroll;
  z-index: 1;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    max-height: 47vh;
  }
`

export const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0.4rem;
  position: relative;
  width: fit-content;
`

export const ContentComment = styled.div<Props>`
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  grid-column: 1 / 3;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    grid-column: 1 / -1;
  }
`

export const ContentInputs = styled.div`
  column-gap: 12px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  padding: 0 8px;
`

export const EmptyExercise = styled.div`
  align-items: center;
  border: 1px dashed ${({ theme }) => theme.colors.text.secondary};
  border-radius: 6px;
  display: flex;
  height: 120px;
  justify-content: center;
  margin: 0 8px 32px;
`

export const HiddenButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0;
`

export const CancelButton = styled(Button).attrs(() => ({
  cancel: true,
  margin: '0',
  size: 'small',
  variation: 'borderless',
}))``

export const ExercisesContainer = styled(Aligner).attrs(() => ({
  flex: 'column',
  gap: '8px',
  padding: '0 0 8px',
}))``

export const Header = styled(Aligner).attrs(() => ({
  align: 'center',
  justify: 'space-between',
  padding: '0 8px 24px',
}))``

export const Input = styled(InputText).attrs(() => ({
  margin: '0',
  scale: 'small',
}))``

export const Legend = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.disabled,
  type: 'copy3',
}))``

export const MobileExerciseButton = styled(Button).attrs(() => ({
  margin: 'auto auto',
  size: 'small',
  variation: 'borderless',
}))``

export const SaveButton = styled(FormButton).attrs(() => ({
  margin: '0',
  size: 'small',
  variation: 'borderless',
}))``

export const Title = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.secondary,
  type: 'copy4',
  weight: 700,
}))``
